"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var navigation_1 = require("next/navigation");
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var LotteryCard = function (_a) {
    var _b;
    var baseLottery = _a.baseLottery;
    var router = (0, navigation_1.useRouter)();
    var translateLocale = (0, swr_hooks_1.useLocaleTranslations)();
    var generateUrlWithLang = (0, apps_shared_1.useGenerateUrlWithLang)();
    var onClickHandler = (0, react_1.useCallback)(function () {
        router.push(generateUrlWithLang("/lotteries/finished/".concat(baseLottery === null || baseLottery === void 0 ? void 0 : baseLottery.slug)));
    }, [router, baseLottery, generateUrlWithLang]);
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.container), onClick: onClickHandler, style: {
            backgroundImage: "url(".concat((_b = baseLottery === null || baseLottery === void 0 ? void 0 : baseLottery.images) === null || _b === void 0 ? void 0 : _b.mobileBanner, ")") || 'initial',
        } },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.content },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.budget }, translateLocale(baseLottery === null || baseLottery === void 0 ? void 0 : baseLottery.budget)),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, translateLocale(baseLottery === null || baseLottery === void 0 ? void 0 : baseLottery.title)))));
};
exports.default = LotteryCard;
